import React, { useCallback, useEffect, Suspense, useState } from "react";
import { API_DEFAULT } from "../config/xano";
import { useObjectStore } from "../zustand/objects";

import { saveUserScreenshotsAPI } from "../api";
import { Card, Button, Stack, Text, Group } from '@mantine/core';

// we need to store the permission key in XANO and then it can be shared with any collaborating user

export const GoogleAuthCallbackPage = () => {

    // const url = window.location.href
    // var regex = /state=([^&]*)/
    // const urlParams = new URLSearchParams(window.location.hash);
    // const stateParam = url.match(regex)[1];
    // const codeParam = urlParams.get('code');
    // const tokenParam = urlParams.get('access_token');

    const urlParams = new URLSearchParams(window.location.search);
    const stateParam = urlParams.get('state');
    const codeParam = urlParams.get('code');


const getGoogleAccessToken = useCallback(() => {
      return fetch(API_DEFAULT + '/googleAccessToken', {
        method: 'POST',
        headers: {
          "content-type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('user')}`
        },
        body: JSON.stringify({
            authorisationCode: codeParam
          }) 
      })
        .then((response) => response.json())
        .then((data) => {
          return data
        })
        .catch((error) => {
          console.error("Error:", error);
    
        });
    }, [codeParam])

// const sendToken = (data) => {
//   return fetch(API_DEFAULT + '/googlesync', {
//     method: 'POST',
//     headers: {
//       "content-type": "application/json",
//       "Authorization": `Bearer ${localStorage.getItem('user')}`
//     },
//     body: JSON.stringify({
//       accessToken: tokenParam
//     })
//   })
//   .then((response) => response.json())
//   .then((data) => {
//     return data
//   })
//   .catch((error) => {
//     console.error("Error:", error);

//   });
// }

//   useEffect(() => {
// // GET ALL A USER'S MIRO BOARDS
// getMiroAccessToken()
// .then(() => getUserMiroBoardsAPI())
// .then((res) => setBoards([...res.response.result.data]))
// .then(() => setHaveToken(true))

//   },[])
  useEffect(() => {
// GET ALL A USER'S MIRO BOARDS
// sendToken(tokenParam)
getGoogleAccessToken()
.then((res) => console.log(res))

  },[getGoogleAccessToken])
    

 
    const GridBackground = () => {
        return (
            <div style={{ position: "fixed", left: 0, top: 0, bottom: 0, zIndex: -1, width: "100%", height: "100vh", backgroundImage: 'url("/image/background-grid.png")', backgroundAttachment: "fixed" }}></div>

        )
    }

    return (
        <div>
            <Suspense fallback={<div>Loading... </div>}>
                <GridBackground />
                <div>
                    <div style={{ marginTop: 64, marginBottom: 32 }}>
                        <div style={{ marginLeft: 80, flexGrow: 1 }}>
                            {/* <Typography component="h1" variant="h4" fontWeight={'700'}>
                                This is where we browse miro projects and pick one to export the mbxr projects to, using the projectKey in the URL.
                            </Typography> */}
                            <a href={`https://mbxr.io/editor/${stateParam}`}>Return to editor</a>
                            {/* <b>You can close this page</b> */}
                        </div>
                    </div>
                    
                  {/* {haveToken && <MiroBoardsMapped boards={boards} projectKey={stateParam}/>} */}
                    
                </div>
            </Suspense>
        </div>
    )
};



export const MiroBoardsMapped = ({projectKey}) => {


  const [haveToken, setHaveToken] = useState(false)
  const [boards, setBoards] = useState([])

const {screenshots, setScreenshotStatus} = useObjectStore()


const screenshotArray = Object.values(screenshots)

const getUserMiroBoardsAPI = (
  data
) => {
  return fetch(API_DEFAULT + '/getMiroBoardsByUser', {
    method: 'GET',
    headers: {
      "content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('user')}`
    },
  })
    .then((response) => response.json())
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error("Error:", error);

    });
}



  useEffect(() => {
    // GET ALL A USER'S MIRO BOARDS
    setScreenshotStatus(true)
getUserMiroBoardsAPI()
.then((res) => setBoards([...res.response.result.data]))
// .then(() => window.setTimeout(function () {
//   saveScreenshots()
// }, 300))
.then(() => setHaveToken(true))

// .then(() => setScreenshotStatus(false))
// .then(() => saveScreenshots())
    
      },[setScreenshotStatus])



    const sendStoryboardToMiro = (data
        ) => {
          return fetch(API_DEFAULT + '/CreateMiroStoryboard', {
            method: 'POST',
            headers: {
              "content-type": "application/json",
              "Authorization": `Bearer ${localStorage.getItem('user')}`
            },
            body: JSON.stringify({
                boardId: data,
                projectKey: projectKey
              })
          })
            .then((response) => response.json())
            .then((data) => {
              return data
            })
            .catch((error) => {
              console.error("Error:", error);
        
            });
        }

    const handleExportClick = (boardId) => {
      // updateScreenshots()
      // .then(() => setShotArtboard())
      // .then(() => saveScreenshots())
      // saveScreenshots()
      saveUserScreenshotsAPI({projectKey:projectKey, screenshots: [...screenshotArray]})
      .then(() => new Promise((resolve) => setTimeout(resolve, 1000)))  // 1000ms (1 second) delay
      .then(() =>sendStoryboardToMiro(boardId))
      .then(() =>setScreenshotStatus(false))
      
    }

return (<> 
    {/* {Object.keys(artboards).map((mapped) => (<div key={mapped} ><Screenshot projectKey={projectKey} guestMode={false} artboard={mapped} /></div>)) } */}
  {haveToken && boards.map((mapped) => (
        <Card key={mapped.id} withBorder radius="xs" p={0} style={{  width:320, marginBottom:16, borderRadius:4, cursor: 'pointer'}}
            shadow="0px 1px 3px 0px rgba(0, 0, 0, 0.05), 0px 1px 2px 0px rgba(0, 0, 0, 0.10)">
          <Group wrap="nowrap" gap={0} >
                <div style={{ width: 100, height: "auto" }}>
                    <img src={mapped.picture.imageURL} alt={`${mapped.name} preview`} style={{width:"100%", height:"100%"}}/></div>
                <Stack style={{marginLeft:20}}>
                    <Text>{mapped.name}</Text>
                <Button
                    onClick={() => handleExportClick(mapped.id)}
                    style={{
                        width: 150, paddingTop: 1, paddingBottom: 1, inline: true, backgroundColor: 'black', borderRadius: 32
                    }}>Export to board</Button>
                    </Stack>
            </Group></Card>
))}</>)

}